// The server's rate limit replies "Request was throttled. Expected available in
// 3412 seconds." Members get a plain sentence with the wait in minutes or hours.
export function tooManyTriesMessage(detail?: unknown): string {
  const match = typeof detail === "string" ? detail.match(/(\d+)\s*seconds?/) : null;
  const seconds = match ? Number(match[1]) : NaN;
  if (!Number.isFinite(seconds) || seconds <= 0) {
    return "Too many tries. Please wait a few minutes and try again.";
  }
  const minutes = Math.ceil(seconds / 60);
  if (minutes <= 1) return "Too many tries. Please wait a minute and try again.";
  if (minutes < 60) return `Too many tries. Please try again in ${minutes} minutes.`;
  const hours = Math.ceil(minutes / 60);
  return hours === 1
    ? "Too many tries. Please try again in about an hour."
    : `Too many tries. Please try again in about ${hours} hours.`;
}
